import FolderPanel from './FolderPanel';
import DetailPanel from "./detail/DetailPanel";
import QuestionPanel from "./QuestionPanel";
import { useParams } from 'react-router-dom'
import React from 'react';
import { store } from '../../../stores/Store';


export default function MainView () {        
    
    const params = useParams()
    
    React.useEffect(() => {
        store.NodeStore.handleUri(params)
        store.AppStore.setPageTitle("AORA")
    }, [params])

    return (
        <div className="view view-main">
            <FolderPanel />            
            <QuestionPanel />
            <DetailPanel />
        </div>
    )
}
